import React from "react";
import { useSelector } from "react-redux";

import { Box } from "@mui/material";

import { NOTIFICATION_GROUPS } from "@constants";

const A11yMessage = () => {
  const {
    [NOTIFICATION_GROUPS.a11y]: { ids, hash },
  } = useSelector((state) => state.notification);

  return (
    <Box
      sx={{
        position: "absolute",
        top: "-1px",
        left: "-1px",
        width: "1px",
        height: "1px",
        padding: 0,
        margin: "-1px",
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        border: 0,
      }}
    >
      {[...(ids || [])].map((id) => (
        <div
          key={`a11y-notification-${id}`}
          className="sr-only"
          role="status"
          aria-live="polite"
          aria-atomic="true"
        >
          {hash[id] ? <span>{hash[id].messages}</span> : ""}
        </div>
      ))}
    </Box>
  );
};

export default A11yMessage;
